// CORS with yarn start
// export const HOST = "https://localhost:8443";
// Production Build
export const HOST = "";
